import script from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./DepositPaymentMethod.vue?vue&type=style&index=0&id=adf84ce4&lang=css"

const __exports__ = script;

export default __exports__